exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popup-wrap .popup-box .commercial_img{\n  border-radius: 10px;\n  width: 100%;\n\tmin-width: 260px;\n\tmax-width: 356px;\n  aspect-ratio: 89 / 150;\n}\n", ""]);

// exports
